import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './app/App';
import reportWebVitals from './reportWebVitals';
import { GoogleOAuthProvider } from '@react-oauth/google';

const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;
if (!GOOGLE_CLIENT_ID) {
  // eslint-disable-next-line no-console
  console.error(
    '[auth] REACT_APP_GOOGLE_CLIENT_ID is not set. Google sign-in will be disabled. ' +
      'Add it to .env and RESTART the dev server (CRA only reads .env at process start).'
  );
}

const rootElement = document.getElementById('root');

// Only hydrate on routes that react-snap actually prerendered.
// Hydrating against a mismatched prerendered DOM (e.g. /sign-in served the
// home-page shell) causes Framer Motion's initial: { opacity: 0 } to get
// stuck, making page content invisible.
const prerenderedRoutes = new Set([
  '/',
  '/about-us',
  '/contact-us',
  '/programs',
  '/programs/explore',
  '/blogs',
  '/courses',
  '/group-calisthenics',
  '/90-day-challenge',
  '/terms-and-conditions',
  '/calisthenics-for-women',
  '/prenatal-postnatal-workout',
  '/online-workout-classes-india',
  '/calisthenics-for-beginners',
  '/working-women-fitness',
  '/7-day-challenge',
]);

const pathname = window.location.pathname.replace(/\/$/, '') || '/';
const isPrerendered = prerenderedRoutes.has(pathname);

if (rootElement.hasChildNodes() && isPrerendered) {
  ReactDOM.hydrateRoot(
    rootElement,
    <React.StrictMode>
      <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID || ''}>
        <App />
      </GoogleOAuthProvider>
    </React.StrictMode>
  );
} else {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID || ''}>
        <App />
      </GoogleOAuthProvider>
    </React.StrictMode>
  );
}

reportWebVitals();
